import { api } from "./api";

export function downloadAction(item) {
  if (item.file_url) {
    window.open(item.file_url, "_blank", "noopener");
    return;
  }
  if (item.file_data) {
    const a = document.createElement("a");
    a.href = item.file_data;
    a.download = item.title || "download";
    a.click();
    return;
  }
  // fallback: fetch detail and try again
  api.get(`/downloads/${item.id}`).then((r) => {
    const d = r.data;
    if (d.file_url) return window.open(d.file_url, "_blank", "noopener");
    if (d.file_data) {
      const a = document.createElement("a");
      a.href = d.file_data;
      a.download = d.title || "download";
      a.click();
    }
  });
}
